/**
 * Whole logical line [start, end) for an offset — same rules as Find Results navigation in AppShell.
 */

export function logicalLineRangeAtOffset(text: string, offset: number): { start: number; end: number } {
  const safeOffset = Math.max(0, Math.min(offset, text.length));
  let lineStart = Math.max(text.lastIndexOf("\n", safeOffset - 1), text.lastIndexOf("\r", safeOffset - 1)) + 1;
  // Caret on the LF in a CRLF pair: `split(/\r\n|\n|\r/)` treats the pair as one break; content starts after `\n`.
  if (
    lineStart < text.length &&
    text.charCodeAt(lineStart) === 10 &&
    lineStart > 0 &&
    text.charCodeAt(lineStart - 1) === 13
  ) {
    lineStart += 1;
  }
  // Find next break from content start so we never return an empty range when more text follows.
  let lineEnd = text.indexOf("\n", lineStart);
  const crEnd = text.indexOf("\r", lineStart);
  if (lineEnd < 0 || (crEnd >= 0 && crEnd < lineEnd)) lineEnd = crEnd;
  if (lineEnd < 0) lineEnd = text.length;
  return { start: lineStart, end: lineEnd };
}
